import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { Category } from "./category.model";

export abstract class CategoryApiFacade<T extends Category> extends AccountObjectApiFacade<T> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.api-facade.ts